import { Component, Input, OnInit } from '@angular/core';
import { PlatformType } from '@root/config';

@Component({
  selector: 'host-edit-status-form-item',
  templateUrl: './edit-status-form-item.component.html',
  styleUrls: ['./edit-status-form-item.component.scss'],
})
export class EditStatusFormItemComponent implements OnInit {
  readonly Platform: typeof PlatformType = PlatformType;
  @Input() data;
  @Input() active = false;
  constructor() {}

  ngOnInit() {
    console.log(' this.data: ', this.data);
  }

  onBookingMinimumChange(data) {
    console.log('data, ', data, ' this.data: ', this.data);
    // if (data.status === 0) {
    //   this.data.minimum_stay = null;
    // } else {
    // }
    this.data.minimum_stay = data.value;
  }
}
